import { render } from "./PanelsGroup.vue?vue&type=template&id=54936d78&scoped=true"
import script from "./PanelsGroup.vue?vue&type=script&lang=js"
export * from "./PanelsGroup.vue?vue&type=script&lang=js"

import "./PanelsGroup.vue?vue&type=style&index=0&id=54936d78&scoped=true&lang=scss"
import "./PanelsGroup.vue?vue&type=style&index=1&id=54936d78&lang=scss"

import exportComponent from "/codebuild/output/src4174910631/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54936d78"]])

export default __exports__